import { isValidLocale, type Locale } from "@/config/locale";

/** Current cookie name — bump when forcing a one-time reset of stored locale/channel prefs. */
export const GEO_PREF_COOKIE = "geo_pref_v2";

/** Previous name (until geo_pref_v2); middleware clears this so browsers drop stale JSON. */
export const LEGACY_GEO_PREF_COOKIE = "geo_pref";

/** Fired after geo preference cookie changes so client UI (e.g. cart pricing) can refetch. */
export const GEO_PREF_UPDATED_EVENT = "eurolabs-peptides-geo-pref-updated";

export function dispatchGeoPrefUpdated(): void {
	if (typeof window === "undefined") return;
	window.dispatchEvent(new Event(GEO_PREF_UPDATED_EVENT));
}

export type ParsedGeoPref = {
	locale: Locale;
	channel: string;
};

/**
 * Parse geo preference cookie JSON (`GEO_PREF_COOKIE`). Validates locale and channel.
 * Legacy `referenceCurrency` in JSON is ignored.
 */
export function parseGeoPrefCookieValue(raw: string | undefined | null): ParsedGeoPref | null {
	if (!raw || typeof raw !== "string") return null;
	try {
		const parsed = JSON.parse(raw) as {
			locale?: string;
			channel?: string;
		};
		if (typeof parsed.locale !== "string" || !isValidLocale(parsed.locale)) return null;
		if (typeof parsed.channel !== "string" || !parsed.channel.trim()) return null;
		const ch = parsed.channel.trim().toLowerCase();
		return { locale: parsed.locale, channel: ch };
	} catch {
		return null;
	}
}
